import { TermForm } from './term-form';
import { TermsFormLinkedField } from './terms-form-linked-field';

function hasValue(val: string | number | null | undefined): boolean {
    if (val == null) return false;
    if (typeof val === 'number') return val !== 0;
    if (typeof val === 'string') return val.trim() !== '';
    return true;
}

export function hasValueForLinkedField(
    termForm: TermForm | null | undefined,
    field: TermsFormLinkedField
): boolean {
    if (!termForm) return false;
    const summary = termForm.purchasePriceSummary;
    const cash = summary?.cashAtCloser;
    switch (field) {
        case TermsFormLinkedField.CashAtCloser:
            return hasValue(cash?.cashAtClose);
        case TermsFormLinkedField.NetCashAtCloser:
            return hasValue(cash?.netCashAtCloser);
        case TermsFormLinkedField.DeferredFixedPayments: {
            const rows = summary?.deferredFixedPayments?.rows ?? [];
            return rows.length > 0 && rows.some((r) => hasValue(r.amount));
        }
        case TermsFormLinkedField.DeferredVariablePayments: {
            const rows = summary?.deferredVariablePayments?.rows ?? [];
            return rows.length > 0 && rows.some((r) => hasValue(r.valueAtClosing));
        }
        case TermsFormLinkedField.JvEquity:
            return hasValue(summary?.jvEquity?.row?.valueAtClosing);
        case TermsFormLinkedField.CorporateEquity:
            return hasValue(summary?.corporateEquity?.row?.valueAtClosing);
        case TermsFormLinkedField.Other:
            return hasValue(summary?.other);
        case TermsFormLinkedField.PracticePropertyPurchased:
            return hasValue(termForm.propertyPurchased?.practicePropertyPurchased);
        case TermsFormLinkedField.PracticeRealPropertyIncluded:
            return hasValue(termForm.propertyPurchased?.practiceRealPropertyInclude);
        default:
            return false;
    }
}
